let mainUtils = function () {};
mainUtils.pathName = function (setSession) {
  let obj = {}, _hash = window.location.hash;
  if (_hash.includes('?')) {
    let pathname = _hash.split('?')[1];
    if (setSession) sessionStorage.setItem(setSession, pathname);
    pathname.split('&').map(item => {
      let _value = item.split('=');
      obj[_value[0]] = _value[1];
    });
  }
  return obj;
};
export default mainUtils


// WEBPACK FOOTER //
// ./src/pub/utils/mainUtils.js